import react from 'react';
import styled from 'styled-components';
import { TierTable } from '@app/pages/MMRPage/block/TierTable.tsx';
import { useTranslation } from 'react-i18next';

export const MMRPage = () => {
  const {t} = useTranslation();

  return (
    <Page>

      <PageContent>
        <Title>
          {t("LeverageandMargin")}
        </Title>

        <Description>
          {t("InitialMarginCalculation")}
        </Description>

        <TierTable/>

        <Description>
          {t("thepriceisextreme")}
        </Description>

      </PageContent>

    </Page>
  )
}

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageContent = styled.div`
  width: 1200px;
  margin-top: 100px;
`;

const Title = styled.div`
    color: ${({theme}) => theme.text};
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
`

const Description = styled.div`
    color: ${({theme}) => theme.text};
  white-space: pre-wrap;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 20px;
  margin-bottom: 40px;
`